const defaultRule = '';

/**
 * 使用数据万象对图片进行处理，文档：https://cloud.tencent.com/document/product/460/6929
 * @param {String} str - 需要处理的 url
 * @param {String} imgRule - 图片处理规则，不包括 format\
 */
const isSupportWebp = (function () {
  try {
    return document.createElement('canvas').toDataURL('image/webp', 0.5)
      .indexOf('data:image/webp') === 0;
  } catch (err) {
    return false;
  }
}());

function mDealImage(url, rule) {
  // 移除现有规则
  url = url
    // .replace(/cos.[^\.]+/, 'image')
    .replace(/imageView2[^&]+/, '')
    .replace('?&', '?');

  // 没有显式包含 q 规则，则图片质量统一设置为 70%
  rule = /\/q\//.test(rule) ? rule : rule + defaultRule;
  // if (isSupportWebp) {
  //   rule += '/format/webp';
  // }
  url = /\?/.test(url)
    ? url.replace('?', `?imageView2/2${rule}&`)
    : `${url}?imageView2/2${rule}`;
  return url;
}

function mHttps(url) {
  return url
    ? url
      .replace(/／/g, '/')
      .replace(/＆/g, '&')
      .replace(/＝/g, '=')
      .replace(/^(https?:)?\/\//g, 'https://')
    : '';
}


export const replaceImgToCloud = function (str, imgRule) {
  if (!str) return '';
  if (str.indexOf('.myqcloud') >= 0) {
    return mHttps(mDealImage(str, imgRule));
  }
  // str = str.replace(/(\/\/itea-cdn.qq.com[^'"]+)/, (match, capture) => match
  //   .replace(capture, mDealImage(capture, imgRule || defaultRule))
  //   .replace('itea-cdn.qq.com', 'gp-itea-1259052908.image.myqcloud.com'));

  // TODO: 裁剪图片
  // str = str.replace(/(\/\/game.gtimg.cn[^'"]+)/, (match, capture) => match
  //   .replace(capture, mDealImage(capture, imgRule || defaultRule))
  //   .replace('game.gtimg.cn', 'gp-gtimg-1259052908.image.myqcloud.com'));

  // str = str.replace(/(\/\/shp.qpic.cn[^'"]+)/, (match, capture) => match
  //   .replace(capture, mDealImage(capture, imgRule || defaultRule))
  //   .replace('shp.qpic.cn', 'gp-shp-1259052908.image.myqcloud.com'));

  // str = str.replace(/(\/\/puui.qpic.cn[^'"]+)/, (match, capture) => match
  //   .replace(capture, mDealImage(capture, imgRule || defaultRule))
  //   .replace('puui.qpic.cn', 'gp-puui-1259052908.image.myqcloud.com'));

  // str = str.replace(/(\/\/img-doujin.qq.com[^'"]+)/, (match, capture) => match
  //   .replace(capture, mDealImage(capture, imgRule || defaultRule))
  //   .replace('img-doujin.qq.com', 'gp-doujin-1259052908.image.myqcloud.com'));
  str = str.replace(/(\/\/img.tgl.qq.com[^'"]+)/, (match, capture) => match
    .replace(capture, mDealImage(capture, imgRule || defaultRule))
    .replace('img.tgl.qq.com', 'gp-tgl-1259052908.image.myqcloud.com'));

  str = str.replace(/(\/\/gzhnews-1251786003.file.myqcloud.com[^'"]+)/, (match, capture) => match
    .replace(capture, mDealImage(capture, imgRule || defaultRule))
    .replace('gzhnews-1251786003.file.myqcloud.com', 'gzhnews-1251786003.image.myqcloud.com'));

  return mHttps(str);
};


/**
 * 详情页富文本替换腾讯云图
 */
// TODO
export const detailTextImg = '';
// function a(str) {
//   str = str.replace(
//     /<img [^>]*src=['"](https\:\/\/itea-cdn.qq.com[^'"]+)[^>]*>/g,
//     (match, capture) => match
//       .replace(capture, mDealImage(capture, defaultRule))
//       .replace('itea-cdn.qq.com', 'gp-itea-1259052908.image.myqcloud.com'),
//   );

//   str = str.replace(
//     /<img [^>]*src=['"](https\:\/\/game.gtimg.cn[^'"]+)[^>]*>/g,
//     (match, capture) => match
//       .replace(capture, mDealImage(capture, defaultRule))
//       .replace('game.gtimg.cn', 'gp-gtimg-1259052908.image.myqcloud.com'),
//   );

//   str = str.replace(
//     /<img [^>]*src=['"](https\:\/\/shp.qpic.cn[^'"]+)[^>]*>/g,
//     (match, capture) => match
//       .replace(capture, mDealImage(capture, defaultRule))
//       .replace('shp.qpic.cn', 'gp-shp-1259052908.image.myqcloud.com'),
//   );

//   str = str.replace(
//     /<img [^>]*src=['"](https\:\/\/puui.qpic.cn[^'"]+)[^>]*>/g,
//     (match, capture) => match
//       .replace(capture, mDealImage(capture, defaultRule))
//       .replace('puui.qpic.cn', 'gp-puui-1259052908.image.myqcloud.com'),
//   );
//   return str;
// };

// function mDealImage(url, rule) {
//   url = url.replace(/cos.[^\.]+/, 'image');
//   if (/(\.webp|\.png)$/.test(url)) {
//     if (/imageView2/.test(rule)) {
//       if (!/\/format/.test(rule)) {
//         rule = `${rule}/format/jpg`;
//       }
//     } else {
//       rule = 'imageView2/format/jpg';
//     }
//   }

//   url =    rule && /\?/.test(url)
//     ? url.replace('?', `?imageView2${rule}&`)
//     : `${url}?imageView2${rule}`;
//   // url = rule ? url + (url.indexOf('?') > -1 ? '&' : '?') + rule : url;
//   return url;
// }
/* #region 判断图片后缀 */
// const arr = url.match(/\.([^\.\?]+)(\?|$)/);
// if (Array.isArray(arr)) {
//   switch (arr[1]) {
//     case 'gif':
//       // 移除格式转换
//       rule = rule.replace(/\/format\/[^\/]+/, '');

//       break;
//     case 'webp':
//       // 没有显式包含 format 规则，则自动转换 iOS 下的 webp 格式图片
//       if (!/\/format\//.test(rule)) {
//         rule = `${rule}/format/jpg`;
//       }

//       break;
//     case 'png':
//       // 没有显式包含 format 规则，则自动转换 iOS 下的 webp 格式图片
//       if (!/\/format\//.test(rule)) {
//         rule = `${rule}/format/jpg`;
//       }

//       break;
//   }
// }
/* #endregion */
